import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';

import MenuSection from '../MenuSection';
import EmptyState from '../EmptyState';
import AvailabilityNotification from '../AvailabilityNotification';

import { classes, st } from './MenuList.st.css';
import { menuListDataHooks } from './constants';
import { useHooks } from './useHooks';

type MenuListProps = {
  className?: string;
};

const MenuList: React.FC<MenuListProps> = ({ className }) => {
  const {
    menus,
    itemAvailabilityByPlacementId,
    availabilityNotificationByMenuId,
    layoutSize,
    showMenuDescription,
    showMenuDivider,
  } = useHooks();

  return (
    <div
      className={st(classes.root, { [layoutSize]: true }, className)}
      data-hook={menuListDataHooks.root()}
    >
      {menus.map((menu) => (
        <div key={menu.id} className={classes.menuBlock} data-menu-id={menu.id}>
          <div className={classes.menuHeader}>
            <Text
              className={classes.menuTitle}
              data-hook={menuListDataHooks.menuTitle()}
              typography={TextTypography.largeTitle}
              tagName="h2"
            >
              {menu.name}
            </Text>
            {availabilityNotificationByMenuId[menu.id] ? (
              <AvailabilityNotification
                className={classes.availabilityNotification}
                dataHook={menuListDataHooks.menuAvailabilityNotification()}
                {...availabilityNotificationByMenuId[menu.id]}
              />
            ) : null}
            {showMenuDescription && menu.description && (
              <Text
                className={classes.menuDescription}
                data-hook={menuListDataHooks.menuDescription()}
                tagName="p"
              >
                {menu.description}
              </Text>
            )}
          </div>
          {menu.sections.length > 0 ? (
            <>
              {showMenuDivider && (
                <div
                  className={classes.divider}
                  data-hook={menuListDataHooks.divider()}
                  role="separator"
                />
              )}
              <div className={classes.sections}>
                {menu.sections.map((section, sectionIndex) => (
                  <MenuSection
                    key={section.id}
                    section={section}
                    menuId={menu.id}
                    currentSectionNumber={sectionIndex + 1}
                    itemAvailabilityByPlacementId={
                      itemAvailabilityByPlacementId
                    }
                  />
                ))}
              </div>
            </>
          ) : (
            <EmptyState />
          )}
        </div>
      ))}
    </div>
  );
};

export default MenuList;
